import React, { Fragment, lazy, Suspense, useEffect, useState } from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import { LayoutSplashScreen } from "../_metronic/layout";
import AllDashboardPages from "./pages/dashboard";
import Profile from "./pages/profile/Profile";
import ChangePassword from "./pages/changepassword/ChangePassword";
import About from "./pages/about";

// pages lists
const UserSettingsPage = lazy(() => import("./pages/user-settings"));
// const UserRolePage = lazy(() => import("./pages/user-settings/roles"));
// const AdminSettingsPage = lazy(() => import("./pages/admin-settings"));
const MasterGridPage = lazy(() => import("./pages/master-grid"));
const RecruitmentPage = lazy(() => import("./pages/recruitement"));
const RequisitionPage = lazy(() => import("./pages/requisition"));
const JobDescriptionPage = lazy(() => import("./pages/job-description"));
const ApplicantPage = lazy(() => import("./pages/applicant"));
const RulesPage = lazy(() => import("./pages/rules"));
const ShiftPage = lazy(() => import("./pages/shift"));
const OffDayPage = lazy(() => import("./pages/off-day"));
const LeavePage = lazy(() => import("./pages/leave-management"));
const HolidayPage = lazy(() => import("./pages/holidays"));
const OverTimePage = lazy(() => import("./pages/over-time"));
const DelegationPages = lazy(() => import("./pages/delegation"));
const Employee = lazy(() => import("./pages/employee"));
const FeaturePermissions = lazy(() => import("./pages/permission"));
const Organogram = lazy(() => import("./pages/organogram"));
const weekendPage = lazy(() => import("./pages/weekend"));
const attendancePage = lazy(() => import("./pages/attendance"));
const WageManagement = lazy(() => import("./pages/wage-management"));
const Policy = lazy(() => import("./pages/policy"));
const Notice = lazy(() => import("./pages/notice"));
const PerformanceManagement = lazy(() => import("./pages/performance"));
const FIA = lazy(() => import("./pages/fia"));
const TFW = lazy(() => import("./pages/tfw"));
const TaxManagement = lazy(() => import("./pages/tax-management"));
const LoanManagement = lazy(() => import("./pages/loan"));
const LetterManagement = lazy(() => import("./pages/letter-management"));
const NotificationPage = lazy(() => import("./pages/notification"));
const FinalSettlementPage = lazy(() => import("./pages/final-settlement"));
const CareerPortalPage = lazy(() => import("./pages/career-portal"));
const ReportsPage = lazy(() => import("./pages/reports"));
const NotificationGlobalView = lazy(() =>
  import("./pages/delegation/NotificationGlobalView")
);
const MasterData = lazy(() => import("./pages/master-data/index"));
const CompanySetting = lazy(() =>
  import("./pages/company-setting/CompanySettings")
);
const PFPage = lazy(() => import("./pages/pf"));
const SupervisorPayment = lazy(() => import("./pages/supervisor-payment"));
const EmployeePoliciesPage = lazy(() => import("./pages/employee-policies"));
const CertificateRequisitionManagement = lazy(() => import("./pages/certificate-requisition"));
const ChildCareService = lazy(() => import("./pages/child-care-service"));
const IDRequisition = lazy(() => import("./pages/id-requisition"));
const NocRequisition = lazy(() => import("./pages/noc-requisition"));
const SalaryCertificateRequisition = lazy(() => import("./pages/salary-certificate"));
export default function BasePage() {
  const [initialKey, setInitialKey] = useState(1);
  const history = useHistory();
  useEffect(() => {
    window.updateRouterInitialKey = function () {
      setInitialKey(Math.ceil(Math.random(0.5) * 1000) + 1);
    };

    if (window.redirect_to) {
      history.push(window.redirect_to);
      window.redirect_to = null;
    }
  }, []);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {<Redirect exact from="/" to="/dashboard" />}
        <Route
          key={initialKey + "_1"}
          // exact
          path="/dashboard"
          component={AllDashboardPages}
        />
        <Route
          key={initialKey + "_2"}
          path="/change-password"
          component={ChangePassword}
        />
        <Route key={initialKey + "_3"} path="/profile" component={Profile} />
        <Route
          key={initialKey + "_4"}
          path="/hrms/user-setting"
          component={UserSettingsPage}
        />
        <Route key={initialKey + "_6"} path="/employee" component={Employee} />
        <Route key={initialKey + "_7"} path="/policy" component={Policy} />
        <Route key={initialKey + "_8"} path="/notice" component={Notice} />
        <Route key={initialKey + "_9"} path="/about" component={About} />
        <Route
          key={initialKey + "_10"}
          path="/requisitons"
          component={RequisitionPage}
        />
        <Route
          key={initialKey + "_11"}
          path="/recruitment"
          component={RecruitmentPage}
        />
        <Route
          key={initialKey + "_12"}
          path="/job-description"
          component={JobDescriptionPage}
        />
        <Route
          key={initialKey + "_14"}
          path="/applicant"
          component={ApplicantPage}
        />
        <Route key={initialKey + "_15"} path="/rules" component={RulesPage} />
        <Route key={initialKey + "_16"} path="/shift" component={ShiftPage} />
        <Route
          key={initialKey + "_17"}
          path="/off-day"
          component={OffDayPage}
        />
        <Route key={initialKey + "_18"} path="/leave" component={LeavePage} />
        <Route
          key={initialKey + "_19"}
          path="/holidays"
          component={HolidayPage}
        />
        <Route
          key={initialKey + "_20"}
          path="/over-time"
          component={OverTimePage}
        />
        <Route
          key={initialKey + "_21"}
          path="/delegation"
          component={DelegationPages}
        />
        <Route
          key={initialKey + "_22"}
          path="/feature-permissions"
          component={FeaturePermissions}
        />
        <Route
          key={initialKey + "_23"}
          path="/organogram"
          component={Organogram}
        />
        <Route
          key={initialKey + "_24"}
          path="/weekend"
          component={weekendPage}
        />
        <Route
          key={initialKey + "_25"}
          path="/payroll"
          component={WageManagement}
        />
        <Route
          key={initialKey + "_26"}
          path="/attendance"
          component={attendancePage}
        />
        <Route
          key={initialKey + "_27"}
          path="/performance"
          component={PerformanceManagement}
        />
        <Route key={initialKey + "_28"} path="/tax" component={TaxManagement} />
        <Route
          key={initialKey + "_29"}
          path="/loan"
          component={LoanManagement}
        />
        <Route
          key={initialKey + "_30"}
          path="/letter"
          component={LetterManagement}
        />
        <Route
          key={initialKey + "_31"}
          path="/notification"
          component={NotificationPage}
        />
        <Route key={initialKey + "_32"} path="/fia" component={FIA} />
        <Route
          key={initialKey + "_33"}
          path="/final-settlement"
          component={FinalSettlementPage}
        />
        <Route key={initialKey + "_34"} path="/tfw" component={TFW} />
        <Route
          key={initialKey + "_35"}
          path="/career-portal"
          component={CareerPortalPage}
        />
        <Route
          key={initialKey + "_39"}
          path="/company-setting"
          component={CompanySetting}
        />
        <Route
          key={initialKey + "_39"}
          path="/reports"
          component={ReportsPage}
        />

        <Route
          key={initialKey + "_37"}
          path="/global-view"
          component={NotificationGlobalView}
        />
        <Route
          key={initialKey + "_36"}
          path="*/masterdata"
          component={MasterGridPage}
        />
        <Route
          key={initialKey + "_38"}
          path="/master-data"
          component={MasterData}
        />
        <Route
          key={initialKey + "_42"}
          path="/pf"
          component={PFPage}
        />
        <Route
          key={initialKey + "_43"}
          path="/supervisor-payment"
          component={SupervisorPayment}
        />
        <Route
          key={initialKey + "_44"}
          path="/employee-policies"
          component={EmployeePoliciesPage}
        />
        <Route
          key={initialKey + "_47"}
          path="/certificate-requisition"
          component={CertificateRequisitionManagement}
        />
        <Route
          key={initialKey + "_45"}
          path="/child-care-service"
          component={ChildCareService}
        />
        <Route
          key={initialKey + "_48"}
          path="/id-requisition"
          component={IDRequisition}
        />
        <Route
          key={initialKey + "_46"}
          path="/noc-requisition"
          component={NocRequisition}
        />
        <Route
          key={initialKey + "_46"}
          path="/salary-certificate"
          component={SalaryCertificateRequisition}
        />
        {/* <Redirect to="error/error-v1" /> */}
      </Switch>
    </Suspense>
  );
}
